module.exports = __webpack_public_path__ + "static/media/Korea_Exhibition_04.bbf62f16.JPG";